// UI string translations for SELAH landing page.
// Long legal documents live in legal_pl.js and legal_en.js.

export const translations = {
  pl: {
    meta: {
      title: "SELAH – Skupienie i Modlitwa",
      description:
        "Prosta aplikacja-timer pomagająca budować rytm pracy, wyciszenia, modlitwy i odpoczynku.",
    },
    nav: {
      features: "Funkcje",
      how: "Jak to działa",
      faq: "FAQ",
      contact: "Kontakt",
      notifyMe: "Powiadom mnie",
    },
    hero: {
      eyebrow: "SELAH · skupienie · modlitwa",
      title: ["Skup się głębiej.", "Realizuj plany skuteczniej."],
      subtitle:
        "SELAH to prosta aplikacja-timer, która znacząco zwiększa Twoją efektywność. Pracujesz w rytmie krótkich, intensywnych sesji bez rozpraszaczy, robisz świadomą przerwę z chwilą wyciszenia lub modlitwy — i wracasz do zadań z większą energią. Dzięki temu kończysz to, co zaplanowałeś.",
      ctaPrimary: "Zobacz, jak działa",
      ctaSecondary: "Skontaktuj się",
      comingSoon: "Wkrótce",
      downloadOn: "Pobierz z",
      onAppStore: "App Store",
      onGooglePlay: "Google Play",
      caption: "Bez konta. Bez e-maila. Same efekty.",
    },
    whatIs: {
      label: "Czym jest SELAH",
      title: "Skupienie, które realnie pcha plany do przodu.",
      body: [
        "SELAH – Skupienie i Modlitwa to narzędzie dla osób, które chcą wykonywać więcej w krótszym czasie — bez wypalenia i pośpiechu. Aplikacja działa jak timer do sesji głębokiego skupienia, oparty na sprawdzonej metodzie pracy w interwałach.",
        "Wybierasz czas, rozpoczynasz sesję i przez wybrany okres koncentrujesz się na jednym zadaniu — pracy, nauce, projekcie lub modlitwie. Bez powiadomień, bez podzielonej uwagi. Ten tryb pracy potrafi zwielokrotnić Twoją produktywność: robisz w godzinę to, co wcześniej zajmowało trzy.",
        "Po sesji aplikacja prowadzi Cię do krótkiej przerwy z cytatem z Pisma Świętego. To moment, w którym odzyskujesz spokój, klarujesz głowę i wracasz do pracy z nową siłą. Tak właśnie buduje się rytm, w którym plany są realizowane do końca — a nie tylko zapisane.",
      ],
    },
    how: {
      label: "Jak to działa",
      title: "Cztery oddechy jednego cyklu.",
      steps: [
        {
          n: "01",
          name: "Skup się",
          desc: "Ustawiasz czas i pracujesz bez rozpraszaczy. Tylko ty i jedno zadanie.",
        },
        {
          n: "02",
          name: "Przerwa",
          desc: "Krótka pauza. Oddech. Aplikacja sama Cię o niej przypomni.",
        },
        {
          n: "03",
          name: "Refleksja",
          desc: "Cytat z Pisma Świętego — moment, w którym przerwa staje się modlitwą.",
        },
        {
          n: "04",
          name: "Odpoczynek",
          desc: "Po kilku sesjach dłuższy odpoczynek. Wracasz spokojniejszy i odzyskany.",
        },
      ],
    },
    features: {
      label: "Najważniejsze funkcje",
      title: "Wszystko, czego potrzebujesz — i ani odrobiny więcej.",
      items: [
        { name: "Timer sesji skupienia", desc: "Czysty, spokojny interfejs sprzyjający koncentracji." },
        { name: "Wybór czasu trwania", desc: "Dopasuj długość sesji do tego, co robisz." },
        { name: "Krótkie przerwy", desc: "Między sesjami — moment na oddech." },
        { name: "Dłuższa przerwa", desc: "Po kilku cyklach przechodzisz do dłuższego odpoczynku." },
        { name: "Statystyki sesji", desc: "Zobacz, ile czasu poświęciłeś na to, co ważne." },
        { name: "Raporty postępów", desc: "Tygodnie, miesiące, serie — w jednym widoku." },
        { name: "Osiągnięcia", desc: "Drobne znaki, które motywują do regularności." },
        { name: "Cytaty z Pisma Świętego", desc: "Inspirujące słowo na czas przerwy i modlitwy." },
      ],
    },
    benefits: {
      label: "Co realnie zyskujesz",
      title: "Większa efektywność. Plany doprowadzone do końca.",
      points: [
        "Robisz więcej w krótszym czasie",
        "Doprowadzasz zadania do końca, zamiast tylko je zaczynać",
        "Pracujesz w skupieniu, bez rozpraszaczy",
        "Budujesz nawyk regularnej, produktywnej pracy",
        "Łączysz skuteczność z momentem wyciszenia i modlitwy",
        "Widzisz w statystykach, jak realnie rośnie Twoja produktywność",
      ],
    },
    privacy: {
      label: "Prywatność na pierwszym miejscu",
      title: "Bez konta. Bez e-maila. Bez śladu.",
      body:
        "SELAH nie wymaga zakładania konta ani podawania adresu e-mail. Możesz po prostu uruchomić aplikację, wybrać czas i rozpocząć sesję.",
    },
    faq: {
      label: "FAQ",
      title: "Pytania, które pewnie chcesz zadać.",
      items: [
        {
          q: "Czy muszę zakładać konto?",
          a: "Nie. SELAH nie wymaga konta ani adresu e-mail, by korzystać z podstawowych funkcji.",
        },
        {
          q: "Na jakich urządzeniach działa?",
          a: "Aplikacja jest projektowana na iOS i Android. Premiera w App Store i Google Play.",
        },
        {
          q: "Czy aplikacja jest dla osób wierzących?",
          a: "Działa dla wszystkich, którzy chcą się skupić. Cytaty z Pisma Świętego można wykorzystać do modlitwy lub potraktować jako krótkie chwile refleksji.",
        },
        {
          q: "Czy SELAH jest darmowy?",
          a: [
            "Tak — SELAH jest darmowy przez 7 dni. W tym czasie masz pełen, nieograniczony dostęp do wszystkich funkcji aplikacji.",
            "Po okresie próbnym aplikacja przechodzi w wersję bezpłatną z limitem 3 sesji dziennie.",
            "Jeśli chcesz korzystać bez limitów, możesz w dowolnym momencie wykupić abonament — szczegóły i cena są prezentowane przed zakupem w App Store lub Google Play.",
          ],
        },
        {
          q: "Co to znaczy „SELAH”?",
          a: "Słowo „SELAH” pojawia się w Psalmach. Jego znaczenie nie jest do końca znane — często interpretuje się je jako pauzę, zatrzymanie, moment ciszy i refleksji nad tym, co przed chwilą zostało powiedziane.",
        },
      ],
    },
    newsletter: {
      label: "Powiadom mnie o premierze",
      title: "Zostawię Ci znać, gdy SELAH będzie gotowe.",
      body: "Bez spamu — jedna wiadomość w dniu premiery.",
      placeholderEmail: "Twój adres e-mail",
      submit: "Zapisz mnie",
      success: "Dziękujemy. Dasz znać znajomym?",
      error: "Coś poszło nie tak. Spróbuj ponownie.",
    },
    contact: {
      label: "Kontakt",
      title: "Napisz do nas.",
      body:
        "Masz pytanie, sugestię lub reklamację? Skorzystaj z formularza lub napisz wprost na adres MCS_KONTAKT@HOTMAIL.COM.",
      name: "Imię (opcjonalnie)",
      email: "Adres e-mail",
      message: "Twoja wiadomość",
      submit: "Wyślij wiadomość",
      success: "Wiadomość wysłana. Odpowiemy w ciągu 14 dni.",
      error: "Nie udało się wysłać wiadomości. Spróbuj ponownie lub napisz e-mail.",
    },
    footer: {
      tagline: "Skupienie i modlitwa.",
      legal: "Dokumenty",
      terms: "Regulamin",
      privacy: "Polityka prywatności",
      contact: "Kontakt",
      back: "Wróć na stronę główną",
      operator: "Operator: MODERN COMMUNICATION SYSTEMS SP. Z O.O.",
      address: "ul. Jeleniogórska 16, 60-179 Poznań, Polska",
      ids: "KRS: 0000441265 · NIP: 7773228737 · REGON: 302284564",
      copyright: "© 2026 SELAH.pl · Wszelkie prawa zastrzeżone.",
    },
    legalLinks: {
      termsPath: "/regulamin",
      privacyPath: "/polityka-prywatnosci",
    },
  },
  en: {
    meta: {
      title: "SELAH – Focus and Prayer",
      description:
        "A simple timer app helping you build a rhythm of work, stillness, prayer and rest.",
    },
    nav: {
      features: "Features",
      how: "How it works",
      faq: "FAQ",
      contact: "Contact",
      notifyMe: "Notify me",
    },
    hero: {
      eyebrow: "SELAH · focus · prayer",
      title: ["Focus deeper.", "Get your plans done."],
      subtitle:
        "SELAH is a simple timer app that meaningfully boosts your effectiveness. You work in short, intense sessions without distractions, take a mindful break with a moment of stillness or prayer — and return to your tasks with renewed energy. That's how you actually finish what you planned.",
      ctaPrimary: "See how it works",
      ctaSecondary: "Get in touch",
      comingSoon: "Coming soon",
      downloadOn: "Download on",
      onAppStore: "App Store",
      onGooglePlay: "Google Play",
      caption: "No account. No email. Just results.",
    },
    whatIs: {
      label: "What is SELAH",
      title: "Focus that actually moves your plans forward.",
      body: [
        "SELAH – Focus and Prayer is a tool for people who want to get more done in less time — without burnout and without rush. The app works as a timer for deep-focus sessions, based on a proven interval-work method.",
        "You choose your time, start the session, and concentrate on one task — work, study, a project or prayer. No notifications, no divided attention. This way of working can multiply your productivity: you do in an hour what used to take three.",
        "After the session the app guides you into a short break with a verse from Scripture. It's the moment when you recover calm, clear your mind, and return to your work with new strength. That's how you build a rhythm where plans are actually finished — not just written down.",
      ],
    },
    how: {
      label: "How it works",
      title: "Four breaths of one cycle.",
      steps: [
        { n: "01", name: "Focus", desc: "Set a time and work without distractions. Just you and one task." },
        { n: "02", name: "Break", desc: "A short pause. A breath. The app will remind you." },
        { n: "03", name: "Reflection", desc: "A verse from Scripture — when the break becomes prayer." },
        { n: "04", name: "Rest", desc: "After a few sessions, a longer rest. You come back restored." },
      ],
    },
    features: {
      label: "Key features",
      title: "Everything you need — nothing more.",
      items: [
        { name: "Focus session timer", desc: "A clean, calm interface that supports concentration." },
        { name: "Custom session length", desc: "Choose a duration that fits what you are doing." },
        { name: "Short breaks", desc: "A moment to breathe between sessions." },
        { name: "Longer rest", desc: "After a few cycles, you move into a longer rest." },
        { name: "Session statistics", desc: "See how much time you gave to what matters." },
        { name: "Progress reports", desc: "Weeks, months, streaks — in a single view." },
        { name: "Achievements", desc: "Small signs that motivate consistency." },
        { name: "Scripture quotes", desc: "Inspiring words for your break and prayer." },
      ],
    },
    benefits: {
      label: "What you actually gain",
      title: "Higher effectiveness. Plans finished, not just started.",
      points: [
        "Get more done in less time",
        "Finish what you start, instead of leaving things half-done",
        "Work in deep focus, free from distractions",
        "Build the habit of consistent, productive work",
        "Combine effectiveness with a moment of stillness and prayer",
        "See real progress in your statistics",
      ],
    },
    privacy: {
      label: "Privacy first",
      title: "No account. No email. No trace.",
      body:
        "SELAH does not require you to create an account or provide an email address. Just open the app, choose a time, and start your session.",
    },
    faq: {
      label: "FAQ",
      title: "Questions you might be asking.",
      items: [
        { q: "Do I need an account?", a: "No. SELAH does not require an account or an email address for the core features." },
        { q: "Which devices are supported?", a: "The app is being designed for iOS and Android. Launching on the App Store and Google Play." },
        { q: "Is the app for religious people only?", a: "It works for anyone wanting to focus. Scripture quotes can be used for prayer or simply as moments of reflection." },
        {
          q: "Is SELAH free?",
          a: [
            "Yes — SELAH is free for the first 7 days. During the trial you get full, unlimited access to every feature.",
            "After the trial, the app switches to a free tier limited to 3 sessions per day.",
            "If you want to use SELAH without limits, you can subscribe at any time — the price and details are presented before purchase in the App Store or Google Play.",
          ],
        },
        { q: "What does “SELAH” mean?", a: "The word “SELAH” appears in the Psalms. Its meaning is not fully known — it is often interpreted as a pause, a stop, a moment of silence to reflect on what has just been said." },
      ],
    },
    newsletter: {
      label: "Notify me at launch",
      title: "We will let you know when SELAH is ready.",
      body: "No spam — one email on launch day.",
      placeholderEmail: "Your email address",
      submit: "Notify me",
      success: "Thank you. Would you tell a friend?",
      error: "Something went wrong. Please try again.",
    },
    contact: {
      label: "Contact",
      title: "Write to us.",
      body:
        "Have a question, suggestion or complaint? Use the form below or write directly to MCS_KONTAKT@HOTMAIL.COM.",
      name: "Name (optional)",
      email: "Email address",
      message: "Your message",
      submit: "Send message",
      success: "Message sent. We will reply within 14 days.",
      error: "Could not send your message. Please try again or write us an email.",
    },
    footer: {
      tagline: "Focus and prayer.",
      legal: "Documents",
      terms: "Terms of Use",
      privacy: "Privacy Policy",
      contact: "Contact",
      back: "Back to home",
      operator: "Operator: MODERN COMMUNICATION SYSTEMS SP. Z O.O.",
      address: "ul. Jeleniogórska 16, 60-179 Poznań, Poland",
      ids: "KRS: 0000441265 · NIP: 7773228737 · REGON: 302284564",
      copyright: "© 2026 SELAH.pl · All rights reserved.",
    },
    legalLinks: {
      termsPath: "/terms",
      privacyPath: "/privacy-policy",
    },
  },
};

export const useT = (lang) => translations[lang] || translations.pl;
